import { Navigate } from "react-router";
import { useUser } from "../../contexts/UserContext";
import { usePortfolioLandingPath } from "@/hooks/usePortfolioLandingPath";

export default function PortfolioRedirect() {
  const { userInfo } = useUser();
  const landingPath = usePortfolioLandingPath();

  if (!userInfo) return null;

  if ((userInfo.trials?.length ?? 0) >= 1) {
    return <Navigate to={landingPath} replace />;
  }

  return null;
}
